import moment from "moment"
import {CheckoutRedemption, Deal, DealRedemption} from "@irati/types"
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes"

export default function isTimeLimited(deal: Deal) {
  return !!deal.isValidFor24Hours
}

export function getTimeLimitedType(deal: Deal) {
  if (isTimeLimited(deal)) {
    return DealHighlightTypes.TIME_LIMIT_24_HOUR
  }

  return deal.typeHighlight
}

// TODO: this can be removed once native uses the new redemption flow
export function getFakeExpiryDate(redemption: DealRedemption) {
  return moment(redemption.date).add(1, "day")
}

export function getFakeExpiryDateForCheckout(redemption: CheckoutRedemption) {
  return moment(redemption.date.nanos).add(1, "day")
}

// TODO: this can be removed once native uses the new redemption flow
export function hasRedemptionExpired(redemption: DealRedemption) {
  if (!isTimeLimited(redemption.deal)) {
    return false
  }

  const now = moment()
  const expiresAt = getFakeExpiryDate(redemption)

  return now > expiresAt
}

export function hasRedemptionExpiredForCheckout(redemption: CheckoutRedemption) {
  if (!isTimeLimited(redemption.dealSnapshot)) {
    return false
  }

  const now = moment()
  const expiresAt = getFakeExpiryDateForCheckout(redemption)

  return now > expiresAt
}
